import {
  ACCESS_REQUEST_IS_COMPLETE,
  ACCESS_REQUEST_IS_ERROR,
  ACCESS_REQUEST_IS_PENDING,
  ACCESS_UPDATE_IS_COMPLETE,
  ACCESS_UPDATE_IS_ERROR,
  ACCESS_UPDATE_IS_PENDING,
  DELETE_ACCESS,
  DELETE_ACCESS_IS_ERROR,
  DELETE_ACCESS_IS_PENDING,
  FETCH_COLOCATION_ACCESS_BY_ID_IS_COMPLETE,
  FETCH_COLOCATION_ACCESS_BY_ID_IS_ERROR,
  FETCH_COLOCATION_ACCESS_BY_ID_IS_PENDING,
  FETCH_COLOCATION_ACCESS_IS_COMPLETE,
  FETCH_COLOCATION_ACCESS_IS_ERROR,
  FETCH_COLOCATION_ACCESS_IS_PENDING,
  FETCH_COLOCATION_REVOKED_ACCESS_IS_COMPLETE,
  FETCH_COLOCATION_REVOKED_ACCESS_IS_ERROR,
  FETCH_COLOCATION_REVOKED_ACCESS_IS_PENDING,
  FILTER_ACCESS,
  RESTORE_ACCESS,
  RESTORE_ACCESS_IS_ERROR,
  RESTORE_ACCESS_IS_PENDING,
  REVOKED_ACCESS,
  REVOKED_ACCESS_IS_ERROR,
  REVOKED_ACCESS_IS_PENDING,
  SORT,
  SORT_REVOKE,
} from 'services/Colocation/ColocationAccess/types';
import { SortDirection } from 'types/common/sorting';
import { sort } from 'utils/functions';

const INITIAL_STATE = {
  access: [],
  details: [],
  revoked: [],
  sortBy: 'Name',
  sortDirection: 'ASC' as SortDirection,
  params: {
    type: 'function',
    sortSearchParam: 'Name',
    sortSearchValue: (item: $TSFixMe) => `${item.firstName} ${item.firstName}`,
  },
  filterBy: 'SHOW_ALL',
  fetchAccessIsCompleted: false,
  fetchAccessIsPending: false,
  fetchAccessIsError: null,
  fetchAccessRevokedIsCompleted: false,
  fetchAccessRevokedIsPending: false,
  fetchAccessRevokedIsError: null,
  fetchAccessDetailsIsCompleted: false,
  fetchAccessDetailsIsPending: false,
  fetchAccessDetailsIsError: null,
  requestAccessIsCompleted: false,
  requestAccessIsPending: false,
  requestAccessIsError: null,
  updateAccessIsCompleted: false,
  updateAccessIsPending: false,
  updateAccessIsError: null,
  deleteAccessIsCompleted: false,
  deleteAccessIsPending: false,
  deleteAccessIsError: null,
  revokeAccessIsCompleted: false,
  revokeAccessIsPending: false,
  revokeAccessIsError: null,
  restoreAccessIsCompleted: false,
  restoreAccessIsPending: false,
  restoreAccessIsError: null,
};

const accessReducer = (
  state = {
    ...INITIAL_STATE,
  },
  action = undefined,
) => {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  switch (action.type) {
    case FILTER_ACCESS:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        filterBy: action.filterBy,
      };
    case SORT:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        sortBy: action.params.sortSearchParam,
        sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        params: action.params,
        access: sort(state.access, {
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortBy: action.params.sortSearchParam,
          sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',

          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortSearchValue: action.params.sortSearchValue || action.params.value,
        }),
      };

    case SORT_REVOKE:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        sortBy: action.params.sortSearchParam,
        sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        params: action.params,
        revoked: sort(state.revoked, {
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortBy: action.params.sortSearchParam,
          sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',

          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortSearchValue: action.params.sortSearchValue || action.params.value,
        }),
      };

    case FETCH_COLOCATION_ACCESS_IS_COMPLETE: {
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        access: sort(action.data, {
          sortBy: state.sortBy,
          sortDirection: state.sortDirection,
          sortSearchValue: state.params.sortSearchValue || (state.params as $TSFixMe).value || null,
        }),
        fetchAccessIsCompleted: true,
        fetchAccessIsPending: false,
        fetchAccessIsError: null,
      };
    }

    case FETCH_COLOCATION_ACCESS_IS_PENDING: {
      return {
        ...state,
        fetchAccessIsCompleted: false,
        fetchAccessIsPending: true,
        fetchAccessIsError: null,
      };
    }

    case FETCH_COLOCATION_ACCESS_IS_ERROR: {
      return {
        ...state,
        fetchAccessIsCompleted: true,
        fetchAccessIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchAccessIsError: action.error,
      };
    }

    // Fetch Revoked

    case FETCH_COLOCATION_REVOKED_ACCESS_IS_COMPLETE: {
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        revoked: sort(action.data, {
          sortBy: state.sortBy,
          sortDirection: state.sortDirection,
          sortSearchValue: state.params.sortSearchValue || (state.params as $TSFixMe).value || null,
        }),
        fetchAccessRevokedIsCompleted: true,
        fetchAccessRevokedIsPending: false,
        fetchAccessRevokedIsError: null,
      };
    }

    case FETCH_COLOCATION_REVOKED_ACCESS_IS_PENDING: {
      return {
        ...state,
        fetchAccessRevokedIsCompleted: false,
        fetchAccessRevokedIsPending: true,
        fetchAccessRevokedIsError: null,
      };
    }

    case FETCH_COLOCATION_REVOKED_ACCESS_IS_ERROR: {
      return {
        ...state,
        fetchAccessRevokedIsCompleted: true,
        fetchAccessRevokedIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchAccessRevokedIsError: action.error,
      };
    }

    // by ID
    case FETCH_COLOCATION_ACCESS_BY_ID_IS_COMPLETE: {
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        details: action.data,
        fetchAccessDetailsIsCompleted: true,
        fetchAccessDetailsIsPending: false,
        fetchAccessDetailsIsError: null,
      };
    }

    case FETCH_COLOCATION_ACCESS_BY_ID_IS_PENDING: {
      return {
        ...state,
        fetchAccessDetailsIsCompleted: false,
        fetchAccessDetailsIsPending: true,
        fetchAccessDetailsIsError: null,
      };
    }

    case FETCH_COLOCATION_ACCESS_BY_ID_IS_ERROR: {
      return {
        ...state,
        fetchAccessDetailsIsCompleted: true,
        fetchAccessDetailsIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchAccessDetailsIsError: action.error,
      };
    }

    case ACCESS_REQUEST_IS_COMPLETE: {
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        access: state.access.concat(action.data),
        requestAccessIsCompleted: true,
        requestAccessIsPending: false,
        requestAccessIsError: null,
      };
    }

    case ACCESS_REQUEST_IS_PENDING: {
      return {
        ...state,
        requestAccessIsCompleted: false,
        requestAccessIsPending: true,
        requestAccessIsError: null,
      };
    }

    case ACCESS_REQUEST_IS_ERROR: {
      return {
        ...state,
        requestAccessIsCompleted: true,
        requestAccessIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        requestAccessIsError: action.error,
      };
    }

    case ACCESS_UPDATE_IS_COMPLETE: {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      const indexToUpdate = state.access.findIndex((item) => (item as $TSFixMe).id === action.data.id);

      return {
        ...state,
        access: state.access.map((item, index) => {
          if (index !== indexToUpdate) {
            return item;
          }

          return {
            // @ts-expect-error ts-migrate(2698) FIXME: Spread types may only be created from object types... Remove this comment to see the full error message
            ...item,

            // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
            ...action.data,
          };
        }),

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        details: action.data,
        updateAccessIsCompleted: true,
        updateAccessIsPending: false,
        updateAccessIsError: null,
      };
    }

    case ACCESS_UPDATE_IS_PENDING: {
      return {
        ...state,
        updateAccessIsCompleted: false,
        updateAccessIsPending: true,
        updateAccessIsError: null,
      };
    }

    case ACCESS_UPDATE_IS_ERROR: {
      return {
        ...state,
        requestAccessIsCompleted: true,
        updateAccessIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        updateAccessIsError: action.error,
      };
    }

    // delete

    case DELETE_ACCESS: {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      const index = state.access.findIndex((x) => (x as $TSFixMe).id === action.data.id);

      return {
        ...state,
        access: [...state.access.slice(0, index), ...state.access.slice(index + 1)],
        deleteAccessIsCompleted: true,
        deleteAccessIsPending: false,
        deleteAccessIsError: null,
      };
    }

    case DELETE_ACCESS_IS_PENDING:
      return {
        ...state,
        deleteAccessIsCompleted: false,
        deleteAccessIsPending: true,
        deleteAccessIsError: null,
      };
    case DELETE_ACCESS_IS_ERROR:
      return {
        ...state,
        deleteAccessIsCompleted: true,
        deleteAccessIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        deleteAccessIsError: action.error,
      };

    // revoked
    case REVOKED_ACCESS: {
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        details: action.data,
        revokeAccessIsCompleted: true,
        revokeAccessIsPending: false,
        revokeAccessIsError: null,
      };
    }

    case REVOKED_ACCESS_IS_PENDING: {
      return {
        ...state,
        revokeAccessIsCompleted: false,
        revokeAccessIsPending: true,
        revokeAccessIsError: null,
      };
    }

    case REVOKED_ACCESS_IS_ERROR: {
      return {
        ...state,
        revokeAccessIsCompleted: true,
        revokeAccessIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        revokeAccessIsError: action.error,
      };
    }

    // restore
    case RESTORE_ACCESS: {
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        details: action.data,
        restoreAccessIsCompleted: true,
        restoreAccessIsPending: false,
        restoreAccessIsError: null,
      };
    }

    case RESTORE_ACCESS_IS_PENDING: {
      return {
        ...state,
        restoreAccessIsCompleted: false,
        restoreAccessIsPending: true,
        restoreAccessIsError: null,
      };
    }

    case RESTORE_ACCESS_IS_ERROR: {
      return {
        ...state,
        restoreAccessIsCompleted: true,
        restoreAccessIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        restoreAccessIsError: action.error,
      };
    }

    case 'RESET_COLOCATION_ACCESS_REDUCER':
    case 'RESET_REDUCER':
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default accessReducer;
